/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { Menu } from '@micromag/core/components';

import styles from '../../../styles/menus/menu.module.scss';

const propTypes = {
    items: PropTypes.array, // eslint-disable-line
    asDropdown: PropTypes.bool,
    asList: PropTypes.bool,
    asLine: PropTypes.bool,
    flush: PropTypes.bool,
    dropdownAlign: MicromagPropTypes.dropdownAlign,
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    linkClassName: PropTypes.string,
    opened: PropTypes.bool,
};

const defaultProps = {
    items: [],
    asList: false,
    asLine: false,
    asDropdown: false,
    flush: false,
    dropdownAlign: 'end',
    className: null,
    itemClassName: null,
    linkClassName: null,
    opened: false,
};

const SiteMenu = ({
    items,
    asList,
    asLine,
    asDropdown,
    flush,
    dropdownAlign,
    className,
    itemClassName,
    linkClassName,
    opened,
    ...props
}) => (
    <Menu
        {...props}
        items={items}
        linkAsItem={asList || asLine}
        className={classNames({
            [styles.container]: true,
            'list-group': asList,
            'list-group-flush': asList && flush,
            'dropdown-menu': asDropdown,
            'dropdown-menu-end': asDropdown,
            show: opened,
            [className]: className !== null,
        })}
        itemClassName={classNames({
            'list-group-item': asList,
            'list-group-item-action': asList,
            'py-2': asList,
            'px-2': asList,
            'py-lg-3': asList,
            'px-lg-3': asList,
            [itemClassName]: itemClassName !== null,
        })}
        linkClassName={classNames({
            'mb-2': asLine,
            'ms-2': asLine,
            btn: asLine,
            'btn-small': asLine,
            'btn-outline-light': asLine,
            'color-light': true,
            'dropdown-item': asDropdown,
            [linkClassName]: linkClassName !== null,
        })}
        dropdownAlign={dropdownAlign}
    />
);

SiteMenu.propTypes = propTypes;
SiteMenu.defaultProps = defaultProps;

export default SiteMenu;
